import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import LoadingSpinner from 'components/LoadingSpinner';
import Footer from 'components/Footer';
import { Cover } from '@chownow/cn-web-components';

import { sanitizeAdminUrl } from '../EmbeddedAdmin/helpers';
import {
  Container,
  StyledIFrame,
  LoadingWrapper,
  TabsContainer,
  TabButton,
  TabContent
} from './styles';

const LOCATION_TABS = {
  GENERAL: 'General',
  ORDERING: 'Ordering',
  DELIVERY: 'Delivery'
} as const;

interface LocationSettingsProps {
  title: string;
}

type LocationTab = typeof LOCATION_TABS[keyof typeof LOCATION_TABS];

const LocationSettings: FC<LocationSettingsProps> = ({ title }) => {
  const adminUrl = process.env.REACT_APP_ADMIN_PYTHON_APP_URL;
  const { restaurantId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<LocationTab>(LOCATION_TABS.GENERAL);

  const handleOnLoad = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
  }, [activeTab]);

  const getIframeSrc = (tabName: string) => {
    const baseUrl = `${sanitizeAdminUrl(adminUrl ?? '')}/restaurant/${restaurantId}`;

    switch (tabName) {
      case LOCATION_TABS.ORDERING:
        return `${baseUrl}?tab=ordering#location-ordering`;
      case LOCATION_TABS.DELIVERY:
        return `${baseUrl}/delivery`;
      default:
        return baseUrl;
    }
  };

  return (
    <>
      <Cover title={title} />
      <Container>
        <TabsContainer>
          {Object.values(LOCATION_TABS).map(tab => (
            <TabButton
              key={tab}
              isActive={activeTab === tab}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </TabButton>
          ))}
        </TabsContainer>
        <TabContent>
          <StyledIFrame
            style={{ display: isLoading ? 'none' : 'block' }}
            src={getIframeSrc(activeTab)}
            title={`admin-${activeTab.toLowerCase()}`}
            onLoad={handleOnLoad}
          />
          {isLoading && (
            <LoadingWrapper>
              <LoadingSpinner isAbsolute={false} withWrapper={false} />
            </LoadingWrapper>
          )}
        </TabContent>
        <Footer embeddedAdmin />
      </Container>
    </>
  );
};

export default LocationSettings;
